import { useMemo } from 'react';

import { useQuery } from "@apollo/client/react";

import { Option } from '../../line';
import { GET_LINE_RICH_MENU_POSTBACK_OPTIONS } from '../graphql';

interface UseGetRichMenuPostbackProps {
  richMenuId?: string;
}

export const useGetRichMenuPostback = ({ richMenuId }: UseGetRichMenuPostbackProps) => {
  const { data, loading } = useQuery(GET_LINE_RICH_MENU_POSTBACK_OPTIONS, {
    skip: !richMenuId,
    variables: {
      input: richMenuId || '',
    },
  });

  const postbackOptions = useMemo(() => {
    if (!data?.LineRichMenu?.template.actions) return [];

    return data.LineRichMenu.template.actions.reduce((acc, action) => {
      if (
        action?.__typename !== 'LineRichMenuPostbackAction' ||
        acc.some((option) => option.value === action.trigger)
      ) {
        return acc;
      }
      return [...acc, { label: action.trigger, value: action.trigger }];
    }, [] as Option[]);
  }, [data?.LineRichMenu?.template.actions]);

  return {
    postbackOptions,
    loading,
    title: data?.LineRichMenu?.title,
  };
};
